// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_override > .form-row > .form-group {
  display: flex;
  margin: 0;
  padding: 0 0px;
}

.help_container {
  display: flex;
}

.ml-5 {
  margin-left: 5px !important;
}

.pl-5 {
  padding-left: 0 !important;
}

.fieldHeader {
  z-index: 9;
  height: 40px;
  align-items: center;
  background-color: #fff;
}

.footer_override > .form-row > .form-group > label {
  max-width: 100px;
  width: 70px;
  min-width: 70px;
}

.apiBodyDisplay {
  font-size: 0.821rem;
  margin-top: 0.3rem;
}

.requestResposneContainer {
  display: inline-block;
  width: 100%;
  background-color: #fff;
  margin-top: -10px;
  max-height: 80vh;
  overflow: hidden;
  padding: 0 18px;
  min-height: 70vh;
}

.rrHeader {
  display: grid;
  grid-column-gap: 12px;
  grid-template-columns: auto auto;
  align-items: center;
  margin: 2px 0 5px 2px;
}

.rrBodyDisplayed {
  border: solid 0.2px #bbbdbf;
  padding: 7px 14px;
  width: 50%;
  max-height: 72vh;
  min-height: 70vh;
}

.rrBodyDisplayed h4 {
  display: inline-block;
  margin: 0;
}

.right {
  float: right;
}

.backClass {
  font-weight: 600;
}

.btn-end {
  text-align: end;
  cursor: pointer;
}

.json-body {
  position: relative;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
  max-height: 72vh;
  min-height: 67vh;
}

.json-body textarea {
  width: calc(100% + 10px);
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  resize: none;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/api-body-editor/api-body-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;AAEF;;AAAA;EAKE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;AADF;;AAGA;EAKE,2BAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EAEA,gBAAA;AALF;;AAQA;EACE,qBAAA;EACA,SAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAOA;EACE,eAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,wBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAJF","sourcesContent":[".footer_override > .form-row > .form-group {\r\n  display: flex;\r\n  margin: 0;\r\n  padding: 0 0px;\r\n}\r\n\r\n.help_container {\r\n  display: flex;\r\n}\r\n\r\n.ml-5 {\r\n  margin-left: 5px !important;\r\n}\r\n.pl-5 {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.fieldHeader {\r\n  z-index: 9;\r\n  height: 40px;\r\n  align-items: center;\r\n  background-color: #fff;\r\n}\r\n\r\n.footer_override > .form-row > .form-group > label {\r\n  max-width: 100px;\r\n  width: 70px;\r\n  min-width: 70px;\r\n}\r\n\r\n.apiBodyDisplay {\r\n  font-size: 0.821rem;\r\n  margin-top: 0.3rem;\r\n}\r\n.requestResposneContainer {\r\n  // display: inline-flex;\r\n  // width: 100%;\r\n  // background-color: #fff;\r\n  // margin-top: -10px;\r\n  display: inline-block;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  margin-top: -10px;\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  padding: 0 18px;\r\n  min-height: 70vh;\r\n}\r\n\r\n.rrHeader {\r\n  display: grid;\r\n  grid-column-gap: 12px;\r\n  grid-template-columns: auto auto;\r\n  align-items: center;\r\n  margin: 2px 0 5px 2px;\r\n}\r\n.rrBodyDisplayed {\r\n  // border: solid 0.2px #bbbdbf;\r\n  // padding: 5px;\r\n  // width: 50%;\r\n  // height: 72vh;\r\n  border: solid 0.2px #bbbdbf;\r\n  padding: 7px 14px;\r\n  width: 50%;\r\n  max-height: 72vh;\r\n  // overflow-y: scroll;\r\n  min-height: 70vh;\r\n}\r\n\r\n.rrBodyDisplayed h4 {\r\n  display: inline-block;\r\n  margin: 0;\r\n}\r\n\r\n.right {\r\n  float: right;\r\n}\r\n\r\n.backClass {\r\n  font-weight: 600;\r\n}\r\n.btn-end {\r\n  text-align: end;\r\n  cursor: pointer;\r\n}\r\n\r\n.json-body {\r\n  position: relative;\r\n  overflow-y: auto;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  max-height: 72vh;\r\n  min-height: 67vh;\r\n}\r\n\r\n.json-body textarea {\r\n  width: calc(100% + 10px);\r\n  height: 100%;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  border: 1px solid #ccc;\r\n  resize: none;\r\n  overflow-y: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
